"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  min-width: 325px;\n  padding-left: ", ";\n  padding-right: ", ";\n  margin-right: auto;\n  margin-left: auto;\n  width: 100%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var ContainerGui = _styledComponents.default.div(_templateObject(), function (_ref) {
  var containerPadding = _ref.containerPadding;
  return typeof containerPadding === 'number' ? "".concat(containerPadding, "px") : containerPadding;
}, function (_ref2) {
  var containerPadding = _ref2.containerPadding;
  return typeof containerPadding === 'number' ? "".concat(containerPadding, "px") : containerPadding;
});

var Container = function Container(_ref3) {
  var containerPadding = _ref3.containerPadding,
      props = (0, _objectWithoutProperties2.default)(_ref3, ["containerPadding"]);
  return /*#__PURE__*/_react.default.createElement(ContainerGui, (0, _extends2.default)({
    containerPadding: containerPadding
  }, props));
};

Container.propTypes = {
  containerPadding: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};
Container.defaultProps = {
  containerPadding: '15px'
};
var _default = Container;
exports.default = _default;